module.exports = __webpack_public_path__ + "img/ice_car.009dea90.png";